import axios from 'axios'
// import { stringify } from 'qs'
axios.defaults.timeout = 300000
// let Base64 = require('js-base64').Base64

// import Vue from 'vue'
// import ElementUI from 'element-ui'

axios.interceptors.response.use(

    (response) => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.data.code === 401) {
            // location.href = '/#/login'
            return Promise.reject(response)
        } else if (response.data.code === 403) {
            // localStorage.clear();
            // ElementUI.MessageBox({
            //   Title: '标题名称',
            //   message: response.data.msg,
            //   callback: action => {
            //     location.href = '/#/login'
            //   }

            // })
            // ElementUI.$confirm(response.data.msg, '提示', {
            // type: 'warning',
            // }).then(() => {

            //   this.$router.push('/login')

            // })
        } else {
            return Promise.resolve(response)
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    (error) => {
        return Promise.reject(error.response)

        //   if (error.response.status) {
        //     switch (error.response.status) {
        //       // 401: 未登录
        //       // 未登录则跳转登录页面，并携带当前页面的路径
        //       // 在登录成功后返回当前页面，这一步需要在登录页操作。
        //       case 401:
        //         vant.Toast.fail("身份验证失败，请关闭重新进入。");
        //         break;

        //       // 403 token过期
        //       // 登录过期对用户进行提示
        //       // 清除本地token和清空vuex中token对象
        //       // 跳转登录页面
        //       case 403:
        //         vant.Toast.fail("登录过期，请关闭重新进入。");
        //         // 清除token
        //         break;

        //       // 404请求不存在
        //       case 404:
        //         vant.Toast.fail("您访问的网页不存在。");
        //         break;
        //       // 其他错误，直接抛出错误提示
        //       default:
        //         vant.Toast.fail(error.response.data.message);
        //     }
        //     return Promise.reject(error.response);
        //   }
    }
)

// 测试服服接口

let base = 'https://ndj-api.zjjunlv.com/version3/'
let baseMaster = 'https://ndj-api-master.zjjunlv.com/'

// let base = 'http://h5.chouchouxia.cn/';

export const baseUrl = base
export const loginUrl = base.replace('/version3/', '/dzplogin')
/* 大转盘详情页 */
export const getDZPDetail = (params, token) => {
    return axios.get(`${base}/Dzp/detail`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}
// 获取中奖名单
export const getDZPPrize = (params, token) => {
    return axios.get(`${base}/Dzp/prize`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}
export const getDZPPage = (params, token) => {
    return axios.get(`${base}/Dzp/page`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}
// 获取二维码邀请码
export const getDZPQrcode = (params, token) => {
    return axios.get(`${base}/Dzp/qrcode`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const getH5Key = (params, token) => {
    return axios.get(`${base}/DzpGzh/h5key`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const postCheckH5Key = (p, token) => {
    return axios
        .post(`${base}/DzpGzh/check`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const getDZPSkinList = (params, token) => {
    return axios.get(`${base}/DzpPcSkin/list`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const postDzpSkin = (p, token) => {
    return axios
        .post(`${base}/DzpPcSkin/list`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const getDZPDIY = (params, token) => {
    return axios.get(`${base}/DzpSkin/diy`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}


export const getMYDIYLIST = (params, token) => {
    return axios.get(`${base}/DzpSkin/mydiylist`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const postDzpSkinDel = (p, token) => {
    return axios
        .post(`${base}/DzpSkin/mydiydel`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}


export const postDZPDIY = (p, token) => {
    return axios
        .post(`${base}/DzpSkin/diy`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const postDZPList = (p, token) => {
    return axios
        .post(`${base}/Dzp/newList`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const getDZPList = (params, token) => {
    return axios.get(`${base}/Dzp/newList`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const openLottery = (p, token) => {
    return axios
        .post(`${base}/Dzp/pause`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const inviteQrcode = (params, token) => {
    return axios.get(`${base}/Dzp/qrcode`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const stopLottery = (p, token) => {
    return axios
        .post(`${base}/dzp/lotteryEnd`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const getPyWins = (params, token) => {
    return axios.get(`${baseMaster}/dzp/pywins`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const checkDZPBuy = (params, token) => {
    return axios.get(`${base}/Dzp/buy`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const postRenewnopay = (p, token) => {
    return axios
        .post(`${base}/Dzp/renewnopay`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const deleteLottery = (p, token) => {
    return axios
        .delete(`${base}/Dzp/lottery`, {
            data: p,
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const getDzpSkinList = (params, token) => {
    return axios.get(`${base}/DzpSkin/list?version_id=4`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const uploadImg = (p, token) => {
    return axios
        .post(`${base}/file`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const createLottery = (p, token) => {
    return axios
        .post(`${base}/Dzp/lottery`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}


export const getLotteryDetail = (params, token) => {
    return axios.get(`${base}/Dzp/lottery`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const getDZPVersion = (params, token) => {
    return axios.get(`${base}/Dzp/version`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}


export const getDZPBuy= (params, token) => {
    return axios.get(`${base}/Dzp/buy`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const postDZPOrder = (p, token) => {
    return axios
        .post(`${base}/Dzp/order`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}

export const getDZPOrder= (params, token) => {
    return axios.get(`${base}/Dzp/order`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}

export const getGzhList= (params, token) => {
    return axios.get(`${baseMaster}/DzpApplyAuth/can_auth?auth_id=`, {
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'X-Token': token
        }
    })
}


export const postReOpen = (p, token) => {
    return axios
        .post(`${base}/Dzp/re_open`, p, {
            headers: {
                'Content-Type': 'application/json',
                'X-Token': token
            }
        })
        .then((res) => res.data)
}



// WEBPACK FOOTER //
// ./src/api/api.js